module.exports = __webpack_public_path__ + "img/rg_object_history_menu_press.65d0b5ab.svg";